import React, {useEffect, useRef, useState} from 'react';
import { ReactComponent as ProductItemSvg } from "./ProductItemSvg.svg";
import { ReactComponent as SoonItemSvg } from "./SoonItemSvg.svg";
import { ReactComponent as NfdPlatformItem } from "./NfdPlatformItem.svg";

interface ProductItemProps {
	id: string;
	stackNote?: any;
  contentId?: string;
	title: string;
	description: string;
	type: "Combine" | "Armor" | "Platform" | "Trading" | "Something" | "Soon";
	isAvailable: boolean;
	onHover: (description: string) => void;
	onLeave: () => void;
}

const ProductItem = (props: ProductItemProps) => {
	const productItemRef = useRef<HTMLDivElement>(null);
	const imageRef = useRef<HTMLDivElement>(null);
	const descriptionRef = useRef<HTMLDivElement>(null);
	const lineRef = useRef<HTMLDivElement>(null);

	const [width, setWidth]   = useState(window.innerWidth);

	const checkBounds = () => {
		if (descriptionRef.current && lineRef.current) {
			const descriptionElement = descriptionRef.current;
			const screenWidth = window.innerWidth;
			const descriptionRect = descriptionElement.getBoundingClientRect();

			if (descriptionRect.right > screenWidth) {
				descriptionElement.style.left = 'auto';
				descriptionElement.style.right = '93px';
				descriptionElement.style.flexDirection = 'row-reverse';
				if (props.type === 'Something') {
					lineRef.current.style.marginLeft = '0';
				} else {
					lineRef.current.style.marginLeft = '0';
				}
			}
			else if (descriptionRect.left < 0) {
				descriptionElement.style.right = 'auto';
				descriptionElement.style.flexDirection = 'row';
				if (props.type === 'Something') {
					lineRef.current.style.marginLeft = '-12px';
					descriptionElement.style.left = '105px';
				} else {
					lineRef.current.style.marginLeft = '0';
					descriptionElement.style.left = '93px';
				}
			}
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			if (window.innerWidth > 767) {
				checkBounds();
			}
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		let animationFrame: number;
		const checkPosition = () => {
			checkBounds();
			animationFrame = requestAnimationFrame(checkPosition);
		};

		if (descriptionRef.current?.style.opacity === '1') {
			animationFrame = requestAnimationFrame(checkPosition);
		}

		return () => cancelAnimationFrame(animationFrame);
	}, [descriptionRef.current?.style.opacity]);

	const handleOnHover = (event: any) => {
		if (width > 767) {
			if (descriptionRef && descriptionRef.current) {
				const descriptionElement = descriptionRef.current;
				descriptionElement.style.opacity = '1';
				descriptionElement.style.height = 'auto';
				descriptionElement.style.transform = 'translateZ(100px)';
				props.stackNote(productItemRef);
				checkBounds();
			}
		} else {
			//console.log("hovered")
			props.onHover(props.description);
		}

		if (imageRef && imageRef.current) {
			imageRef.current.style.scale = width < 768 ? width < 425 ? '1.2' : '0.9' : '1.2';
		}
	};

	const handleOnLeaveHover = () => {
		if (width > 767) {

			if (descriptionRef && descriptionRef.current && lineRef.current) {
				const descriptionElement = descriptionRef.current;
				descriptionElement.style.opacity = '0';
				descriptionElement.style.height = '0';
				descriptionElement.style.right = 'auto';
				descriptionElement.style.flexDirection = 'row';
				if (props.type === 'Something') {
					descriptionElement.style.left = '105px';
				} else {
					descriptionElement.style.left = '93px';
				}
			}
		} else {
			props.onLeave();
		}

		if (imageRef && imageRef.current) {
			imageRef.current.style.scale = width < 768 ? width < 425 ? '1' : '0.7' : '1';
		}
	};

	return (
		<div
			id={props.id}
			className={`productItem ${props.type}`}
			ref={productItemRef}
		>
			<div
				id={props.contentId}
				className="productItem__content"
			>
				<div
					ref={imageRef}
					className={`productItem__content_image ${props.isAvailable && 'available'}`}
					onMouseEnter={handleOnHover}
					onMouseLeave={handleOnLeaveHover}
				>
					{
						props.isAvailable ? (
							<div className={`imageItem ${props.type}`}>
								<ProductItemSvg />
								{
									props.type === 'Platform' ? (
										<div className={`image ${props.type}`}>
											<NfdPlatformItem />
										</div>
									) : (
										<img
											className={`image ${props.type}`}
											src={`${process.env.PUBLIC_URL}/assets/images/Nfd${props.type}.svg`}
											alt={`Image ${props.type}`}
										/>
									)
								}
							</div>
						) : (
							<div className={`imageItem`} >
								<SoonItemSvg />
								<img
									className={`image ${props.type}`}
									src={`${process.env.PUBLIC_URL}/assets/images/Nfd${props.type}.svg`}
									alt={`Image ${props.type}`}
								/>
							</div>
						)
					}
				</div>
				<div className="productItem__content_info">
					<p>{props.title}</p>
				</div>
				{
					props.description && (
							<div
								ref={descriptionRef}
								className="productItem__content_description"
								style={{
									pointerEvents: "none",
								}}
							>
								<div ref={lineRef} className="productItem__content_description_line"></div>
								<div className="productItem__content_description_block">
									<span>{props.description}</span>
								</div>
						</div>
					)
				}
			</div>
		</div>
	);
};

export default ProductItem;
